import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import _ from 'lodash';
var shallowEqual = function shallowEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (!_.isObject(a) || a === null || !_.isObject(b) || b === null) {
    return false;
  }
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);
  if (keysA.length !== keysB.length) {
    return false;
  }
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || a[keysA[i]] !== b[keysA[i]]) {
      return false;
    }
  }
  return true;
};
var withPureRender = function withPureRender(Component) {
  var PureRender = /*#__PURE__*/function (_React$Component) {
    function PureRender() {
      _classCallCheck(this, PureRender);
      return _callSuper(this, PureRender, arguments);
    }
    _inherits(PureRender, _React$Component);
    return _createClass(PureRender, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        return !shallowEqual(this.props, nextProps);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(Component, this.props);
      }
    }]);
  }(React.Component);
  PureRender.displayName = Component.displayName;
  return PureRender;
};
export default withPureRender;